import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { Bar } from 'react-chartjs-2';
import randomstring from 'uuid/v4';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import ModifyRange from './ModifyRange';

function getDataSet(initial, current, props) {
    return {
        labels: initial.map((d) => {
            return d.hora;
        }),
        datasets: [
            {
                label: props.intl.formatMessage({ id: 'modification_forecast_current' }),
                data: initial.map((d) => {
                    return d.importe;
                }),
                backgroundColor: 'rgba(85, 94, 212, 1)',
            },
            {
                label: props.intl.formatMessage({ id: 'modification_forecast_new' }),
                data: current.map((d) => {
                    return d.importe;
                }),
                backgroundColor: 'rgba(163, 171, 222, 1)',
            },
        ],
    };
}

class Forecast extends React.Component {
    state = {
        initial:
            this.props && this.props.info && this.props.info.initial ? this.props.info.initial : [],
        current:
            this.props && this.props.info && this.props.info.current ? this.props.info.current : [],
        data: getDataSet(
            this.props && this.props.info && this.props.info.initial ? this.props.info.initial : [],
            this.props && this.props.info && this.props.info.current ? this.props.info.current : [],
            this.props,
        ),
        leyend: undefined,
        disabled: false,
        hours:
            this.props && this.props.info && this.props.info.initial
                ? this.props.info.initial.map((d, index) => {
                    return { name: d.hora, id: index };
                })
                : [],
        currentId: randomstring(),
    };

    static getDerivedStateFromProps(props, state) {
        if (props.forecast && (props.ventadia !== state.ventadia || props.id !== state.id)) {
            state.disabled = props.disabled;
            state.ventadia = props.info ? props.ventadia : 0;
            state.id = props.id;
            state.leyend = props.leyend;
            state.initial = props && props.info && props.info.initial ? props.info.initial : [];
            state.current = props && props.info && props.info.current ? props.info.current : [];
            state.data = getDataSet(state.initial, state.current, props);
            state.currentId = randomstring();
            state.hours =
                props && props.info && props.info.current
                    ? props.info.current.map((d, index) => {
                        return { name: d.hora, id: index, disabled: d.bloqueado };
                    })
                    : [];
            return state;
        }
        return null;
    }

    handleUpdate = (percentage, from, to) => {
        const { current, initial } = this.state;
        current.map((c, index) => {
            if (
                index >= parseInt(from, 10) &&
                index <= parseInt(to, 10) &&
                !c.bloqueado
            ) {
                c.importe =
                    Math.round((c.importe + (c.importe * parseInt(percentage, 10)) / 100) * 100) /
                    100;
                return c;
            } else {
                return c;
            }
        });
        const ventadia = current.reduce((total, c) => {
            return (total = total + c.importe);
        }, 0);
        this.props.onChange('ventadia', ventadia);
        this.props.onChange('importe', current);
        this.setState({
            current: current,
            currentId: randomstring(),
            data: getDataSet(initial, current, this.props),
        });
    };

    handleChange = (index, value) => {
        const { current, initial } = this.state;
        current[index].importe = parseInt(value, 10);
        const ventadia = current.reduce((total, c) => {
            return (total = total + c.importe);
        }, 0);
        this.props.onChange('ventadia', ventadia);
        this.props.onChange('importe', current);
        this.setState({
            current: current,
            ventadia: ventadia,
            data: getDataSet(initial, current, this.props),
        });
    };

    render() {
        const { intl } = this.props;
        const { initial, current, data, leyend, disabled, hours, currentId } = this.state;
        return (
            <Card className={'production_forecast_card'}>
                <CardContent>
                    <Grid container className={'flex_grow_1'}>
                        <Grid item xs={12} className="">
                            <div className="barlow_medium c_dark_grey_blue text_align_left">
                                {intl.formatMessage({ id: 'production_forecast_title' })}
                            </div>
                        </Grid>
                        <Grid item xs={12} className="">
                            <article className="canvas-container">
                                <Bar
                                    height={200}
                                    width={100}
                                    data={data}
                                    options={{
                                        maintainAspectRatio: false,
                                        legend: {
                                            display: true,
                                            position: 'bottom',
                                        },
                                        scales: {
                                            yAxes: [
                                                {
                                                    scaleLabel: {
                                                        display: true,
                                                        labelString: leyend,
                                                    },
                                                    ticks: {
                                                        beginAtZero: true,
                                                        min: 0,
                                                    },
                                                },
                                            ],
                                        },
                                    }}
                                />
                            </article>
                        </Grid>
                        {!disabled && (
                            <Grid item xs={12} className="padding_top_24">
                                <ModifyRange hours={hours} onUpdate={this.handleUpdate} />
                            </Grid>
                        )}
                        <Grid item xs={12} className="padding_top_24">
                            <Grid container className={'flex_grow_1'}>
                                {current &&
                                    current.map((c, index) => {
                                        const before = initial[index];
                                        return (
                                            <Grid
                                                key={`current-${index}-${currentId}`}
                                                item
                                                xs={2}
                                                className="margin_bottom_24"
                                            >
                                                <div className="flex_full_row padding_right_36">
                                                    {c.pasado &&
                                                        <div className="flex_full_row c_bluish barlow_regular_small margin_bottom_5">
                                                            {c.hora}
                                                        </div>
                                                    }
                                                    {!c.pasado &&
                                                        <div className="flex_full_row c_cool_grey barlow_regular_small margin_bottom_5">
                                                            {c.hora}
                                                        </div>
                                                    }

                                                    {before.importe !== c.importe && (
                                                        <span className="flex_auto_row text_align_end barlow_regular_small c_purple nowrap">
                                                            {before.importe + ' ' + leyend}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="flex_full_row padding_right_36">
                                                    {c.bloqueado || disabled ? (
                                                        <span className="flex_full_row text_align_end barlow_regular c_dark_grey_blue">
                                                            {c.importe + ' ' + leyend}
                                                        </span>
                                                    ) : (
                                                            <TextField
                                                                fullWidth
                                                                id={`forecast-${index}`}
                                                                name={`forecast-${index}`}
                                                                required
                                                                className={'flex_full_row'}
                                                                classes={{
                                                                    root: 'production_total_card_input',
                                                                }}
                                                                defaultValue={c.importe}
                                                                onChange={(event) =>
                                                                    this.handleChange(
                                                                        index,
                                                                        event.target.value,
                                                                    )
                                                                }
                                                                margin="normal"
                                                                InputProps={{
                                                                    pattern: '[0-9]*',
                                                                    classes: {
                                                                        input:
                                                                            'c_dark_grey_blue barlow_regular text_align_right',
                                                                    },
                                                                    endAdornment: (
                                                                        <InputAdornment
                                                                            position="end"
                                                                            classes={{
                                                                                root:
                                                                                    'production_total_card_adornment',
                                                                            }}
                                                                        >
                                                                            {leyend}
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                </div>
                                            </Grid>
                                        );
                                    })}
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

Forecast.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Forecast);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecast/Forecast.js